/**
 * Yugen Build Difficulty — inline legend expand/collapse.
 *
 * Note: do not store the legend panel on `this.popover` — that collides with
 * the native HTMLElement.popover Popover API property.
 */
if (!customElements.get('yugen-build-difficulty')) {
  customElements.define(
    'yugen-build-difficulty',
    class YugenBuildDifficulty extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.infoButton = this.querySelector('[data-ybd-info]');
        this.legend = this.querySelector('[data-ybd-popover]');
        if (!this.infoButton || !this.legend) return;

        this.open = false;
        this.closeTimer = null;
        this.onToggle = this.onToggle.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.infoButton.addEventListener('click', this.onToggle);
      }

      disconnectedCallback() {
        this.infoButton?.removeEventListener('click', this.onToggle);
        this.removeEventListener('keydown', this.onKeydown);
        if (this.closeTimer) window.clearTimeout(this.closeTimer);
      }

      onToggle(event) {
        event.preventDefault();
        this.setOpen(!this.open);
      }

      onKeydown(event) {
        if (!this.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.setOpen(false);
          this.infoButton.focus();
        }
      }

      setOpen(next) {
        const shouldOpen = Boolean(next);
        if (shouldOpen === this.open) return;

        this.open = shouldOpen;
        this.infoButton.setAttribute('aria-expanded', this.open ? 'true' : 'false');

        if (this.closeTimer) {
          window.clearTimeout(this.closeTimer);
          this.closeTimer = null;
        }

        if (this.open) {
          this.legend.hidden = false;
          // Allow the browser to apply display before expanding.
          void this.legend.offsetHeight;
          this.legend.classList.add('is-open');
          this.addEventListener('keydown', this.onKeydown);
          return;
        }

        this.legend.classList.remove('is-open');
        this.removeEventListener('keydown', this.onKeydown);

        const panel = this.legend;
        const finish = () => {
          if (this.open) return;
          panel.hidden = true;
        };

        panel.addEventListener('transitionend', finish, { once: true });
        this.closeTimer = window.setTimeout(finish, 320);
      }
    }
  );
}
